// removed by extract-text-webpack-plugin
module.exports = {"loading":"loading___3EWAa","inline":"inline___5dfqt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/index.scss
// module id = 96
// module chunks = 0